import { render, staticRenderFns } from "./VenueOverview.vue?vue&type=template&id=39ce26a8&scoped=true&"
import script from "./VenueOverview.vue?vue&type=script&lang=js&"
export * from "./VenueOverview.vue?vue&type=script&lang=js&"
import style0 from "./VenueOverview.vue?vue&type=style&index=0&id=39ce26a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ce26a8",
  null
  
)

export default component.exports